module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue2.5c4cee63.jpg";